<template>
  <div>
  <v-dialog v-model="dialog" eager max-width="88%" scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="secondary" class="mr-2">mdi-database-export</v-icon>
        <span class="md-text">New Export</span>
        <v-chip x-small outlined color="grey" class="ml-3">
          Step {{ currentItem + 1 }} of 2
        </v-chip>
        <v-btn icon class="ml-auto" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0" style="max-height: 82vh; overflow-y: auto">
        <v-col cols="12" class="ma-0" v-if="loading">
          <loadingProgress :loading="loading" text="Loading notification..." />
        </v-col>
        <v-col cols="12" class="ma-0 pa-0 pb-2" v-show="!loading">
          <v-text-field
            v-model="inputName"
            label="Exportation name"
            hide-details
            dense
            outlined
          ></v-text-field>
        </v-col>

        <v-tabs v-show="!loading" grow background-color="#eee" v-model="currentItem">
          <v-tab>
            <v-icon small left>mdi-web</v-icon>
            Websites
          </v-tab>
          <v-tab>
            <v-icon small left>mdi-filter-variant</v-icon>
            Filters &amp; Preview
          </v-tab>
        </v-tabs>
        <v-tabs-items v-show="!loading" v-model="currentItem" class="pt-4">
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="py-0">
                <div class="text--secondary ma-0 mt-2 md-text">Uncheck to exclude website</div>
              </v-col>
              <v-col cols="12" class="ma-0">
                <v-checkbox
                  dense
                  hide-details
                  class="ma-0 font-weight-medium"
                  label="Select all websites"
                  v-model="select_all"
                  @change="selectAll"
                >
                </v-checkbox>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="ma-0"
                v-for="(website, index) in websites"
                :key="index"
              >
                <v-checkbox dense hide-details class="ma-0" v-model="website.checked">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <img
                        :src="
                          'https://8181.integ.crawlo.com/favicon?size=xs&website=' + website.url
                        "
                        @error="replaceByDefault"
                        width="30"
                        height="30"
                        class="mr-2 favicon-img"
                      />{{ website.alias }}
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item eager>
            <v-row>
              <v-col cols="12">
                <filterInputs
                  :exportation="true"
                  :component_name="component_name"
                  :opened="dialog"
                  @filter-changed="filterChanged"
                  @load-data="previewData"
                />
              </v-col>
              <v-col cols="12" class="mt-2">
                <div class="text--secondary text-caption mb-2 d-flex align-center">
                  <v-icon x-small class="mr-1" color="grey">mdi-eye-outline</v-icon>
                  Preview — products matching the selected filters
                </div>
                <pricesSimpleTable
                  :filter="table_filter"
                  :changed="data_changes"
                  :component_name="component_name"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-btn text small color="grey darken-1" class="text-none" @click="dialog = false">
          <v-icon left small>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <!-- Step 1: Websites -->
        <template v-if="currentItem === 0">
          <v-btn color="primary" class="text-none" :disabled="loading" @click="currentItem = 1">
            Next
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <!-- Step 2: Filters & Preview -->
        <template v-else>
          <v-btn outlined color="grey darken-1" class="text-none mr-3" @click="currentItem = 0">
            <v-icon left small>mdi-arrow-left</v-icon>
            Back
          </v-btn>
          <submitButton
            :submitFunction="openScheduleDialog"
            :submit_loading="submit_loading"
            text="Generate Export"
            icon="mdi-database-export"
            color="secondary"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Export options dialog -->
  <v-dialog v-model="schedule_dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="d-flex align-center pb-2">
        <v-icon color="secondary" class="mr-2">mdi-database-export</v-icon>
        <span class="md-text">Export options</span>
        <v-btn icon class="ml-auto" :disabled="submit_loading" @click="schedule_dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <!-- Schedule -->
        <div :class="schedule_enabled ? 'mb-4' : 'mb-2'">
          <div class="d-flex align-center mb-1">
            <v-icon small class="mr-2" color="grey darken-1">mdi-calendar-clock</v-icon>
            <span class="font-weight-medium">Daily schedule</span>
            <span class="text--secondary text-caption ml-2">optional</span>
          </div>
          <p class="text--secondary text-caption mb-3">
            Run this export automatically every day.
          </p>
          <v-row no-gutters align="center">
            <v-col cols="auto">
              <v-switch
                v-model="schedule_enabled"
                hide-details
                dense
                inset
                class="ma-0 pa-0"
                label="Enable daily schedule"
              ></v-switch>
            </v-col>
          </v-row>
        </div>

        <!-- Email recipients — shown only when schedule is enabled -->
        <template v-if="schedule_enabled">
          <v-divider class="mb-4"></v-divider>
          <div class="mb-2">
            <div class="d-flex align-center mb-1">
              <v-icon small class="mr-2" color="grey darken-1">mdi-email-multiple-outline</v-icon>
              <span class="font-weight-medium">Additional recipients</span>
              <span class="text--secondary text-caption ml-2">optional</span>
            </div>
            <p class="text--secondary text-caption mb-2">
              The export will always be sent to your account email. Add extra addresses below.
            </p>
            <v-chip small outlined color="grey darken-1" class="mb-3" style="cursor: default">
              <v-icon small left>mdi-email-check-outline</v-icon>
              {{ userEmail }}
            </v-chip>
            <v-row no-gutters align="center" class="mb-2">
              <v-col>
                <v-text-field
                  v-model="email_input"
                  label="Add email address"
                  prepend-inner-icon="mdi-email-outline"
                  dense
                  outlined
                  hide-details="auto"
                  :error-messages="email_input_error ? 'Please enter a valid email address' : ''"
                  @keydown.enter.prevent="addEmail"
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="ml-2">
                <v-btn icon color="primary" @click="addEmail">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="extra_emails.length" class="mt-1">
              <v-chip
                v-for="(email, i) in extra_emails"
                :key="i"
                close
                small
                class="mr-1 mb-1"
                color="primary"
                outlined
                @click:close="extra_emails.splice(i, 1)"
              >
                {{ email }}
              </v-chip>
            </div>
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="px-6 pb-4 pt-4">
        <v-btn
          text
          class="text-none"
          color="grey darken-1"
          :disabled="submit_loading"
          @click="schedule_dialog = false"
        >
          <v-icon left small>mdi-arrow-left</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          class="text-none"
          :loading="submit_loading"
          @click="submitExportRequest"
        >
          <v-icon left small>mdi-database-export</v-icon>
          Generate Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>
  import axios from 'axios'
  import filterInputs from '../common/filterInputs.vue'
  import pricesSimpleTable from '../common/pricesSimpleTable.vue'
  export default {
    name: 'exportationModal',
    props: ['show', 'component_name'],
    components: {
      filterInputs,
      pricesSimpleTable,
    },
    data() {
      return {
        dialog: false,
        select_all: true,
        websites: {},
        inputName: '',
        loading: true,
        currentItem: 0,
        submit_loading: false,
        export_modal_opend: false,
        filter_matchs: true,
        table_filter: {},
        data_changes: false,
        schedule_enabled: false,
        schedule_time: '08:00',
        time_menu: false,
        schedule_dialog: false,
        extra_emails: [],
        email_input: '',
        email_input_error: false,
      }
    },
    computed: {
      userEmail() {
        return localStorage.getItem('email') || '—'
      },
    },
    methods: {
      previewData(payload) {
        this.table_filter = payload
        this.data_changes = !this.data_changes
      },
      filterChanged(payload) {
        this.table_filter = payload
      },
      openScheduleDialog() {
        this.email_input = ''
        this.email_input_error = false
        this.schedule_dialog = true
      },
      addEmail() {
        const val = this.email_input.trim()
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)
        if (!valid) {
          this.email_input_error = true
          return
        }
        if (!this.extra_emails.includes(val)) {
          this.extra_emails.push(val)
        }
        this.email_input = ''
        this.email_input_error = false
      },
      confirmExport(withSchedule) {
        this.schedule_enabled = withSchedule
        this.submitExportRequest()
      },
      submitExportRequest() {
        this.submit_loading = true
        setTimeout(() => {
          let exclude_websites = this.websites
            .filter((website) => {
              return !website.checked
            })
            .map((elt) => elt.alias)

          axios
            .post('/api/exportation/exportrequest', {
              data: {
                account: localStorage.getItem('account_id'),
                user: localStorage.getItem('user_id'),
                component: this.component_name,
                export_name: this.inputName,
                exclude_websites: exclude_websites,
                only_data: this.filter_matchs,
                filter: this.table_filter,
                schedule: {
                  enabled: this.schedule_enabled,
                  time: this.schedule_enabled ? this.schedule_time : null,
                },
                email: localStorage.getItem('email'),
                extra_emails: this.extra_emails,
              },
            })
            .then((response) => {
              if (response.status == 201) {
                this.$emit('show-redirect-modal')
                this.export_modal_opend = true
              } else {
                this.showNotification({
                  msg: "Your export '" + this.inputName + "' Not successfully submited",
                  type: 'error',
                })
              }
            })
            .finally(() => {
              this.dialog = false
              this.schedule_dialog = false
              this.submit_loading = false
            })
        }, 1000)
      },
      showNotification(payload) {
        this.snackbar_color = payload.type
        this.snackbar_msg = payload.msg
        this.snackbar_icon = payload.icon
        this.snackbar = !this.snackbar
        this.changed = !this.changed
      },
      getAccountWebsites() {
        this.websites = []
        this.inputName = ''
        this.loading = true
        axios
          .get('/api/exportation/websites', {
            params: {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
              component: this.component_name,
            },
          })
          .then((res) => {
            this.websites = res.data.map((elt) => {
              elt.checked = true
              return elt
            })
          })
          .finally(() => {
            this.loading = false
          })
      },

      selectAll() {
        this.websites.map((elt) => {
          elt.checked = this.select_all
        })
      },
    },
    watch: {
      show: {
        handler() {
          this.dialog = true
          this.currentItem = 0
          this.filter_matchs = true
          this.schedule_enabled = false
          this.schedule_time = '08:00'
          this.schedule_dialog = false
          this.extra_emails = []
          this.email_input = ''
          this.email_input_error = false
          this.getAccountWebsites()
        },
      },
      websites: {
        handler() {
          let all_checked = true
          for (let i = 0; i < this.websites.length; i++) {
            if (!this.websites[i].checked) {
              all_checked = false
              break
            }
          }
          this.select_all = all_checked
        },
        deep: true,
      },
    },
  }
</script>
